export default "__VITE_ASSET__CMIN6CW0__"